"use client";

import { motion } from "framer-motion";
import { Button } from "./button";

export const MotionButton = motion.create(Button);
